import { useQuery } from '@tanstack/react-query';

import { InsightsApi } from 'api';
import { getFiBankStore } from 'stores/FiBankStore';
import { INSIGHTS_METADATA_KEY } from 'tanstack-hooks/keys';

export function useInsightsMetadata() {
  const insightsApi = new InsightsApi();
  const bankStore = getFiBankStore();

  const { data: insightsMetadata, isLoading: isLoadingInsightsMetadata } = useQuery({
    enabled: !!bankStore.bank.id,
    queryKey: [INSIGHTS_METADATA_KEY, bankStore.bank.id],
    queryFn: () => insightsApi.fetchInsightsMetadata(bankStore.bank.id)
  });

  return { insightsMetadata, isLoadingInsightsMetadata };
}
